import React from 'react';
import { ActivityIndicator, ScrollView, StyleSheet, Text, View } from 'react-native';
import { Popup } from './Popup';
import { useGetHivesQuery } from '../screens/MyHives/useGetHivesQuery.gql';
import { MyHiveCard } from './MyHiveCard';
import { HiveSize } from '../../constants/constants';

export function SelectHivePopUp({
  isVisible,
  onDismiss,
  onSelectHive,
}: {
  isVisible: boolean;
  onDismiss?: () => void;
  onSelectHive?: (hiveDetail: { name: string; id: string; size: HiveSize }) => void;
}) {
  const { data: hivesData, loading: hivesLoading, error: hivesError } = useGetHivesQuery();

  return (
    <Popup
      title="Select Hive"
      visible={isVisible}
      setVisible={() => onDismiss?.()}
      hasHeader={true}
      closeOnBackdropPress={false}
    >
      <ScrollView
        style={styles.hivesList}
        contentContainerStyle={[
          styles.hivesListContentContainer,
          hivesData?.hives.length === 1 && { justifyContent: 'center', flex: 1 },
        ]}
      >
        {(hivesLoading || !hivesData?.hives) && <ActivityIndicator size="large" color="#E89823" />}
        {hivesError && <Text>Error loading hives.</Text>}
        {hivesData?.hives.length === 0 && <Text>No hives available.</Text>}
        {hivesData?.hives?.map(hive => (
          <View style={styles.cardWrapper} key={hive.id}>
            <MyHiveCard
              hive={hive}
              isTeacher={false}
              onPress={value =>
                onSelectHive?.({
                  id: value.id,
                  name: value.name,
                  size: value.size,
                })
              }
            />
          </View>
        ))}
      </ScrollView>
    </Popup>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardWrapper: {
    margin: 8,
  },
  hivesList: {
    flex: 1,
  },
  hivesListContentContainer: {
    alignItems: 'center',
    paddingVertical: 25,
  },
});
